export const RESOURCE_TYPE = {
  Asset: 'assets',
  Attachment: 'attachments',
  Brandfolder: 'brandfolders',
  Collection: 'collections',
  Organization: 'organizations'
}



// WEBPACK FOOTER //
// ./src/services/model.js